import { Injectable } from '@angular/core';
import { ISites } from '../interfaces/ISites';

export interface IUserInfo {
  userName?: string;
  name?: string;
  windowsNT?: string;
  employeeNumber?: string;
  pk_site?: number;
  role?: string;
  sites?: ISites[];
}

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  private _userInfo: IUserInfo = {};

  /**
   * Asigna parcialmente datos del usuario (sin sobrescribir los existentes).
   */
  setUserInfo(partialInfo: Partial<IUserInfo>) {
    this._userInfo = {
      ...this._userInfo,
      ...partialInfo
    };
  }

  /**
   * Limpia completamente los datos del usuario.
   */
  clearUserInfo() {
    this._userInfo = {};
  }

  // Getters individuales

  get userName(): string {
    return this._userInfo.userName || '';
  }

  get name(): string {
    return this._userInfo.name || '';
  }

  get windowsNT(): string {
    return this._userInfo.windowsNT || '';
  }

  get employeeNumber(): string {
    return this._userInfo.employeeNumber || '';
  }

  get pk_site(): number {
    return this._userInfo.pk_site ?? 0;
  }

  get role(): string {
    return this._userInfo.role || '';
  }

  get sites(): ISites[] {
    return this._userInfo.sites || [];
  }

  // Acceso completo al objeto (opcional)
  get userInfo(): IUserInfo {
    return this._userInfo;
  }
}
